import { useEffect, useState } from "react";
import AddToListModal from "../../../../../../Components/FormGenerator/addToListModal";
import { useDispatch } from "react-redux";
import { TOGGLE_GROWING_LIST_POPUP } from "../../../../../../Redux/actions";
import { Select, MenuItem, Input, TextField, Tooltip } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { dateFinder } from "../../../../../../Components/FormGenerator/datepicker_component";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { staticValueFinder } from "../HelperFunctions";
import CustomRendererOpener from "./CustomRenderer";
import FiscalYearComponent from "./CustomComponents/FiscalYearComponent";

export const partnerTypeFields = {
  Assessor: [
    "PartnerAssessmentProfile_assessment_clients",
    "PartnerAssessmentProfile_assessment_clients_testimonials",
    "PartnerAssessmentProfile_assessment_exp_overview",
    "PartnerAssessmentProfile_representative_engagements",
    "PartnerAssessmentProfile_types_of_assessment",
  ],
  "Executive Coach": [
    "PartnerCoachingProfile_approach",
    "PartnerCoachingProfile_client_coaching_testimonials",
    "PartnerCoachingProfile_coaching_areas_of_expertise",
    "PartnerCoachingProfile_level_of_clients_coached",
    "PartnerCoachingProfile_overview",
    "PartnerCoachingProfile_representative_engagements",
    "PartnerCoachingProfile_represntative_clients",
  ],
  Facilitator: [
    "PartnerFacilitationProfile_client_testimonials",
    "PartnerFacilitationProfile_facilitation_areas_of_expertise",
    "PartnerFacilitationProfile_facilitation_clients",
    "PartnerFacilitationProfile_facilitation_exp_overview",
    "PartnerFacilitationProfile_representative_facilitation_programmes",
    "PartnerFacilitationProfile_topics",
  ],
  Mentor: [
    "PartnerMentoringProfile_approach",
    "PartnerMentoringProfile_client_testimonials",
    "PartnerMentoringProfile_clients_mentored",
    "PartnerMentoringProfile_mentoring_areas_of_expertise",
    "PartnerMentoringProfile_overview",
    "PartnerMentoringProfile_representative_clients",
    "PartnerMentoringProfile_representative_engagements",
  ],
};
const validationTypesRegex = {
  number: /^[0-9]*$/,
  email: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
};
const setToList = (setFunction, columnId) => {
  setFunction((prev) => {
    if (prev.includes(columnId)) {
      return prev;
    }
    return [...prev, columnId];
  });
};
const removeFromList = (removeFunction, columnId) => {
  removeFunction((prev) => {
    return prev.filter((el) => el !== columnId);
  });
};

const BodyEditCell = (props) => {
  const { getValue, row, column, table, cell, rowState } = props;
  const {
    dropdowns,
    setDropdowns,
    notFilledMandatoryFields,
    setNotFilledMandatoryFields,
    setNoProperInputFields,
    updateData,
  } = rowState;

  const dispatch = useDispatch();

  //  Column definitions
  const {
    componentType,
    disabled,
    addNewOption,
    optionsKey,
    id,
    dropDown,
    field_name,
    required,
    customComponentKey,
    validationType,
  } = cell.column.columnDef;

  let initialValue = null;

  const [value, setValue] = useState(initialValue);

  const [error, setError] = useState(
    notFilledMandatoryFields.includes(column.id)
  );

  const [showAddNewModal, setShowAddNewModal] = useState(false);

  const onBlur = () => {
    const staticValue = staticValueFinder(componentType, {
      getValue: () => value,
      getContext: () => {},
    });

    if (staticValue !== "") {
      updateData(row.original.id, column.id, value);
      if (notFilledMandatoryFields.includes(column.id)) {
        removeFromList(setNotFilledMandatoryFields, column.id);
        setError(false);
      }
    } else {
      if (required) {
        setError(true);
        setToList(setNotFilledMandatoryFields, column.id);
      } else {
        updateData(row.original.id, column.id, value);
        removeFromList(setNotFilledMandatoryFields, column.id);
        setError(false);
      }
    }
  };

  const dropdownOptions = dropdowns[optionsKey || ""];

  useEffect(() => {
    let existingValue = getValue();
    const staticValueInitial = staticValueFinder(componentType, {
      getValue: getValue,
      getContext: () => {},
    });

    // Checking for mandatory values on first render of the component;
    const isNotValidStaticValueInitial =
      staticValueInitial === "" ||
      staticValueInitial === "-" ||
      staticValueInitial == undefined ||
      staticValueInitial === null;
    if (isNotValidStaticValueInitial && required) {
      setError(true);
      setToList(setNotFilledMandatoryFields, column.id);
    } else {
      setError(false);
    }

    if (validationType && !isNotValidStaticValueInitial) {
      const isValid = new RegExp(validationTypesRegex[validationType]).test(
        staticValueInitial
      );

      if (isValid) {
        setError(false);
        removeFromList(setNoProperInputFields, column.id);
      } else {
        setError(true);
        setToList(setNoProperInputFields, column.id);
      }
    }

    setValue(existingValue || null);
  }, [initialValue]);

  // Add new option
  const handleAddNew = (event) => {
    event.preventDefault();
    setShowAddNewModal(true);
    dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
  };

  // After adding new option
  const handleAddNewValue = (newValue, newId) => {
    setDropdowns((prev) => {
      const oldDrops = { ...prev };
      oldDrops[optionsKey] = [
        ...oldDrops[optionsKey],
        { id: newId, value: newValue },
      ];
      return oldDrops;
    });
    setValue({ id: newId, value: newValue });
  };

  const handleCustomSubmit = (columnId, cellValue) => {
    updateData(row.original.id, columnId, cellValue);
    removeFromList(setNotFilledMandatoryFields, columnId);
    setError(false);
  };
  const handleMultiSelectValues = (event) => {
    if (event.target.value === "Add New") {
      handleAddNew(event);
    } else {
      setValue((prev) => {
        const currentValueArr = event.target.value;
        const currentValue = currentValueArr[currentValueArr.length - 1];
        const existingOps =
          prev?.map((el) => {
            return dropdownOptions.find((ell) => {
              return ell.value === el.value;
            });
          }) || [];
        const isExisting = !(
          existingOps.findIndex((el) => {
            return el.value === currentValue;
          }) === -1
        );
        if (isExisting) {
          return [...existingOps.filter((el) => el.value !== currentValue)];
        } else {
          return [
            ...existingOps,
            {
              value: currentValue,
              id: dropdownOptions?.find((el) => el.value === currentValue)?.id,
            },
          ];
        }
      });
    }
  };

  const componentDefiner = (compType, initial, rowData) => {
    let inputValue = initial;

    /**
     * ///////////Disabled fields based on Partner type /////////
     */
    const partnerTypesItems = rowData?.PartnerProfile_type_of_partner?.map(
      (item) => {
        if (
          item.value &&
          Object.keys(partnerTypeFields)?.includes(item.value)
        ) {
          return item.value;
        }
      }
    );
    const filterItem = Object.keys(partnerTypeFields)?.filter(
      (item) => !partnerTypesItems?.includes(item)
    );

    let disableKeys = [];

    filterItem.forEach((item) => {
      disableKeys = disableKeys?.concat([...partnerTypeFields?.[item]]);
    });
    console.log("disableKeys", disableKeys, id, disableKeys?.includes(id));
    /** /////////////////////////// */
    switch (compType) {
      case "text":
        let fieldTypeMessage = "";
        if (validationType) {
          if (validationType === "number") {
            fieldTypeMessage = "Please enter numbers only";
          }
          if (validationType === "email") {
            fieldTypeMessage = "Please enter a valid email address ";
          }
        }
        return (
          <TextField
            value={disableKeys?.includes(id) ? "Disabled" : inputValue}
            defaultValue={inputValue}
            onChange={(e) => {
              const inputtedValue = e.target.value;
              setValue(inputtedValue);
              if (validationType && inputtedValue) {
                const isValid = new RegExp(
                  validationTypesRegex[validationType]
                ).test(inputtedValue);
                if (isValid) {
                  setError(false);
                  removeFromList(setNoProperInputFields, id);
                } else {
                  setError(true);
                  setToList(setNoProperInputFields, id);
                }
              }
            }}
            // if (e.target.value !== "") {
            //   if (validationType === "number") {
            //     if (
            //       new RegExp(validationTypesRegex["number"]).test(
            //         e.target.value
            //       )
            //     ) {
            //       setValue(e.target.value);
            //       setError(false);
            //       removeFromList(setNoProperInputFields, id);
            //     } else {
            //       setToList(setNoProperInputFields, id);
            //       setError(true);
            //     }
            //   } else if (validationType === "email") {
            //     if (
            //       new RegExp(validationTypesRegex["email"]).test(
            //         e.target.value
            //       )
            //     ) {
            //       setError(false);
            //       removeFromList(setNoProperInputFields, id);
            //     } else {
            //       setError(true);
            //       setToList(setNoProperInputFields, id);
            //     }
            //     setValue(e.target.value);
            //   } else {
            //     setValue(e.target.value);
            //   }
            // } else {
            //   setValue(e.target.value);
            // }
            disabled={disabled || disableKeys?.includes(id)}
            onBlur={onBlur}
            error={error}
            fullWidth
            inputProps={{
              style: {
                fontSize: "12px",
                zIndex: "inherit",
                backgroundColor: "#fff",
              },
            }}
            required={required}
            title={fieldTypeMessage}
          />
        );

      case "dropdown":
        if (typeof inputValue === "string") {
          inputValue = dropdownOptions?.find(
            (el) => el.value?.toLowerCase() === inputValue?.toLowerCase()
          );
        }
        return (
          <Select
            value={inputValue}
            defaultValue={inputValue}
            onBlur={onBlur}
            onChange={(event) => {
              if (event.target.value === "Add New") {
                handleAddNew(event);
              } else {
                setValue({
                  value: event.target.value,
                  id: dropdownOptions?.find(
                    (el) => el.value === event.target.value
                  )?.id,
                });
              }
            }}
            required={required}
            id={id + "_select"}
            fullWidth
            key={id + "_select"}
            Input={
              <Input
                style={{ fontSize: "12px" }}
                value={disableKeys.includes(id) ? "Disabled" : ""}
              />
            }
            renderValue={(o) => (
              <div style={{ fontSize: "12px" }}> {o?.value} </div>
            )}
            disabled={disabled || disableKeys?.includes(id)}
            error={error}
          >
            {dropdownOptions?.map((option) => (
              <MenuItem
                key={option?.value}
                style={{ fontSize: "12px" }}
                value={option?.value}
              >
                {option?.value}
              </MenuItem>
            ))}
            {dropdownOptions && addNewOption && (
              <MenuItem
                key="Add New"
                style={{ fontSize: "12px" }}
                value="Add New"
              >
                + Add New
              </MenuItem>
            )}
          </Select>
        );

      case "multiSelect":
        return (
          <Select
            value={inputValue || []}
            multiple
            onBlur={onBlur}
            defaultValue={inputValue || []}
            required={required}
            error={error}
            onChange={handleMultiSelectValues}
            disabled={disabled || disableKeys?.includes(id)}
            id={id + "_multi_select"}
            fullWidth
            key={id + "_multi_select"}
            Input={
              <Input
                inputProps={{
                  style: {
                    fontSize: "12px",
                  },
                }}
              />
            }
            renderValue={(selected) => {
              const textContent = selected
                ?.map((selectedEl) => selectedEl.value)
                .join(",");

              return (
                <Tooltip title={textContent}>
                  <div style={{ fontSize: "12px" }}>{textContent}</div>
                </Tooltip>
              );
            }}
          >
            {dropdownOptions?.map((option) => (
              <MenuItem
                key={option?.value}
                value={option?.value}
                style={{
                  backgroundColor: value
                    ?.map((el) => el.value)
                    ?.includes(option?.value)
                    ? "#aaa"
                    : "#fff",
                  fontSize: "12px",
                }}
              >
                {option?.value}
              </MenuItem>
            ))}
            {dropdownOptions && addNewOption && (
              <MenuItem
                key="Add New"
                style={{ fontSize: "12px" }}
                value="Add New"
              >
                + Add New
              </MenuItem>
            )}
          </Select>
        );

      case "dropdown_predictive":
        if (typeof inputValue === "string") {
          inputValue = dropdownOptions?.find(
            (el) => el.value?.toLowerCase() === inputValue?.toLowerCase()
          );
        }
        return (
          <Autocomplete
            id={"autoComplete" + id}
            ListboxProps={{
              style: {
                fontSize: "12px",
              },
            }}
            disabled={disabled}
            options={
              [
                ...(dropdownOptions || []),
                dropdownOptions &&
                  addNewOption && { id: "add_new", value: "+ Add New" },
              ] || []
            }
            onBlur={onBlur}
            onChange={(event, newValue) => {
              // props.parentcall(newValue);
              if (newValue?.id === "add_new") {
                handleAddNew(event);
              } else {
                setValue(newValue);
              }
            }}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                return option;
              } else if (
                option &&
                typeof option === "object" &&
                option?.value
              ) {
                return option?.value;
              }
              return "";
            }}
            style={{ width: "100%" }}
            value={inputValue}
            defaultValue={inputValue}
            renderInput={(params) => {
              const { inputProps, InputProps, ...otherParams } = params;
              inputProps.style = {
                fontSize: "12px",
              };
              return (
                <TextField
                  {...otherParams}
                  InputProps={InputProps}
                  inputProps={inputProps}
                  fullWidth
                  required={required}
                  error={error}
                />
              );
            }}
          />
        );
      case "datePicker":
        return (
          <KeyboardDatePicker
            onChange={(event) => {
              setValue(dateFinder(event.toISOString()));
            }}
            disabled={disabled}
            error={error}
            onBlurCapture={onBlur}
            clearable
            DialogProps={{
              style: {
                fontSize: "12px",
              },
            }}
            helperText=""
            margin="dense"
            required={required}
            size="small"
            fullWidth
            clearLabel
            value={inputValue}
            format="dd/MM/yyyy"
            InputProps={{
              readOnly: true,
              value: dateFinder(inputValue),
              style: {
                fontSize: "12px",
              },
            }}
          />
        );

      case "uploadFiles":
        return <input type="file" id="live-view" disabled />;
      case "fiscalYear":
        return (
          <div style={{ width: "100%" }}>
            <FiscalYearComponent
              inputValue={inputValue}
              rowState={rowState}
              cell={cell}
              error={error}
              table={table}
              row={row}
              handleCustomSubmit={handleCustomSubmit}
            />
          </div>
        );
      case "customComponent":
        if (customComponentKey) {
          return (
            <CustomRendererOpener
              inputValue={inputValue}
              handleCustomSubmit={handleCustomSubmit}
              rowState={rowState}
              cell={cell}
              error={error}
              table={table}
              row={row}
            />
          );
        } else {
          return "-";
        }

      default:
        return "-";
    }
  };

  return (
    <div style={{ width: "100%", backgroundColor: "#fff", zIndex: "inherit" }}>
      {componentDefiner(componentType, value, row?.original)}
      {showAddNewModal && (
        <AddToListModal
          setShowModal={setShowAddNewModal}
          postData={{ drop_down: dropDown, field_name: field_name }}
          type={"organization"}
          handleAddNewValue={handleAddNewValue}
          orgParams={{ organisation_id: cell.row.original.id }}
        />
      )}
    </div>
  );
};
export default BodyEditCell;
